import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

interface DelayLinkProps {
  to: string;
  delay?: number; // Delay in milliseconds (default: 500)
  children: React.ReactNode;
  replace?: boolean; // Whether to replace the current history entry
  onDelayStart?: (e: React.MouseEvent) => void;
  onDelayEnd?: (e: React.MouseEvent) => void;
}

const DelayLink: React.FC<DelayLinkProps> = ({
  to,
  delay = 100,
  children,
  replace = false,
  onDelayStart,
  onDelayEnd,
  ...rest
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    // Prevent default behavior
    e.preventDefault();

    // If navigating to the same page, do nothing
    if (location.pathname === to) return;

    // Call onDelayStart if provided
    if (onDelayStart) onDelayStart(e);

    // Set timeout for delayed navigation
    const timeoutId = setTimeout(() => {
      if (replace) {
        navigate(to, { replace: true });
      } else {
        navigate(to);
      }

      // Call onDelayEnd if provided
      if (onDelayEnd) onDelayEnd(e);
    }, delay);

    // Cleanup timeout on unmount
    return () => clearTimeout(timeoutId);
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};

export default DelayLink;   